// credit: https://stackoverflow.com/a/2901298
const addCommas = (x: string): string => x.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

// return with trailing zeroes so that strings are correctly formatted e.g. £3.50 or 1.20kg
const formatNumber = (value: number, dp: number): string => addCommas(value.toFixed(dp))

const formatNumberString = (value: string, dp: number): string => formatNumber(
  parseFloat(value), dp
)

const formatPrice = (price: number): string => `£${formatNumber(price, 2)}`

const formatPriceString = (price: string): string => formatPrice(parseFloat(price))

export {
  addCommas, formatNumber, formatNumberString, formatPrice, formatPriceString
}
